/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{color as o}from"../../../value/types/color/index.js";import{complex as e}from"../../../value/types/complex/index.js";import{dimensionValueTypes as m}from"./dimensions.js";import{testValueType as r}from"./test.js";const s=[...m,o,e],t=o=>s.find(r(o));export{t as findValueType};
//# sourceMappingURL=find.js.map
